import { elements } from '@ecosystem/newron-design-system';
import { IconColor } from '@ecosystem/newron-design-system/build/components/icons/Icon';
import { ReactElement } from 'react';

interface Props {
  icon: ReactElement;
  iconColor: () => IconColor;
  onClick: () => void;
  testId?: string;
}

export const WithNavigationIcon: React.FC<Props> = ({ icon, iconColor, onClick, testId }) => {
  const { Icon } = elements;

  return (
    <span onClick={onClick} onKeyDown={onClick} role="button" tabIndex={0} data-testid={testId}>
      <Icon color={iconColor()}>{icon}</Icon>
    </span>
  );
};
